<template>
  <div class="card">
    <header class="header-card">
      <p>{{ $t('ajoutEditContrat.informationFinanciere.title')}}</p>
    </header>
    <div class="card-content">
      <avertissement-msg-component :title="'general.warning'"
                            :avertissement="avertissement"
                            :canClose="true"
                            :messages="[{ message:
                              'ajoutEditContrat.messages.warning.updateTauxTva'
                              }]">
        </avertissement-msg-component>
      <div class="columns is-multiline">
        <div class="column is-3">
          <b-field :label="$t('ajoutEditContrat.informationFinanciere.montantHt')">
            <input-currency :peutEtreNegatif="true"
                            v-model="contrat.loyerAnnuelHt" isNumber="true"
                            @input="calculAndUpdateMontant"></input-currency>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('ajoutEditContrat.informationFinanciere.tauxTva')">
            <b-select v-model="contrat.tauxTva" expanded
                      @input="calculAndUpdateTva">
              <option v-for="tva in regimeTva"
                      :key="tva.tauxTva"
                      :value="tva.tauxTva">
                {{ tva.tauxTva | formatPercent }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('ajoutEditContrat.informationFinanciere.loyerAnnuelTva')">
            <input-currency :peutEtreNegatif="true"
                            :value="contrat.loyerAnnuelTva" :disabled="true">
            </input-currency>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('ajoutEditContrat.informationFinanciere.montantTtc')">
            <input-currency :peutEtreNegatif="true"
                            :value="contrat.loyerAnnuelTtc" :disabled="true">
            </input-currency>
          </b-field>
        </div>
      </div>
    </div>
    <b-modal v-model="openPopUpPrevention" has-modal-card class="modal">
      <pop-up-prevention
        :mess-header="$t('ajoutEditContrat.updateARapprocher.title')"
        :cancel="$t('general.button.cancel')"
        :validate="$t('general.button.next')"
        @yes="updateAllARapprocher"
        @no="openPopUpPrevention = false">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import inputCurrency from '@/components/general/inputCurrency';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import {
  ECHEANCE_ENREGISTRER,
  ECHEANCE_BROUILLON,
} from '@/configuration/baux/contrat/echeancier/echeancier';
import popUpPrevention from '@/components/general/popUpPrevention';
import avertissementMsgComponent from '@/components/general/avertissementMsgComponent';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'informationsFinanciere',
  data() {
    return {
      openPopUpPrevention: false,
      tauxTvaDefault: 0,
      avertissement: false,
    };
  },
  components: {
    inputCurrency,
    popUpPrevention,
    avertissementMsgComponent,
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    updateAllARapprocher() {
      this.contrat.echeancier.forEach((echeance) => {
        if ((echeance.etat === ECHEANCE_BROUILLON
          || echeance.etat === ECHEANCE_ENREGISTRER)
          && !echeance.aRapprocher) {
          echeance.aRapprocher = true;
        }
      });
      this.openPopUpPrevention = false;
    },
    calculAndUpdateTva() {
      this.avertissement = false;
      if (this.contrat.tauxTva !== 0) {
        this.contrat.intervenants.forEach((intervenant) => {
          intervenant.surFacture = true;
        });
        this.openPopUpPrevention = this.contrat.echeancier.some((echeance) => {
          return ((echeance.etat === ECHEANCE_BROUILLON
            || echeance.etat === ECHEANCE_ENREGISTRER)
            && !echeance.aRapprocher);
        });
      }
      this.calculateMontantTTCAndLoyerAnnuelTva();
      this.echeancier.pourcentageTva = this.contrat.tauxTva;

      if (this.$route.params.id && this.tauxTvaDefault !== this.contrat.tauxTva) {
        this.avertissement = this.contrat.echeancier.some((echeance) => {
          return ((echeance.etat === ECHEANCE_BROUILLON
            || echeance.etat === ECHEANCE_ENREGISTRER));
        });
      }
    },
    calculAndUpdateMontant() {
      this.calculateMontantTTCAndLoyerAnnuelTva();
      this.echeancier.montantAnnuelHt = this.contrat.loyerAnnuelHt;
    },
    calculateMontantTTCAndLoyerAnnuelTva() {
      this.contrat.loyerAnnuelTtc = this.contrat.loyerAnnuelHt
        + (this.contrat.loyerAnnuelHt * this.contrat.tauxTva / 100);
      this.contrat.loyerAnnuelTva = this.contrat.loyerAnnuelTtc - this.contrat.loyerAnnuelHt;
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    regimeTva() {
      return this.parametre(PARAMETRES_KEYS.regimeTva).filter((tva) => {
        return tva.actif || this.contrat.tauxTva === tva.tauxTva;
      });
    },
  },
  props: {
    contrat: {
      type: Object,
      required: true,
    },
    echeancier: {
      type: Object,
      required: true,
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.$route.params.id) {
        this.tauxTvaDefault = this.contrat.tauxTva;
      }
      await this.loadParametres([PARAMETRES_KEYS.regimeTva]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
